import React, { useEffect } from "react";

import { FaArrowRight, FaRegClock } from "react-icons/fa6";
import { Link } from "react-router-dom";

const CookiePolicy = () => {
    return (


        <div className="container mx-auto flex flex-col items-center justify-between px-4 lg:px-6 mb-0 z-30">

            <div className=" flex flex-col mb-12">
                <h1 data-aos='fade-right' duration='1000' className="w-full mx-auto text-left text-blue-text font-light text-3xl lg:text-4xl my-16 lg:mx-0">
                    COOKIE <span className="font-semibold">POLICY</span>
                </h1>


                <p data-aos='fade-right' duration='1000' className="w-full mx-auto text-left text-blue-text font-bold text-xl lg:mt-0 lg:mx-0 underline">
                    USO DEI COOKIE
                </p>

                <p data-aos='fade-right' duration='1000' className="text-base font-normal text-black mb-4">
                    VILLA PAPA GIOVANNI XXIII S.R.L. o il “Sito” utilizza i Cookie per rendere i propri servizi semplici e efficienti per l’utenza che visiona le pagine del Sito.<br />
                    Gli utenti che visionano il Sito, vedranno inserite delle quantità minime di informazioni nei dispositivi in uso, che siano computer e periferiche mobili, in piccoli file di testo denominati “cookie” salvati nelle directory utilizzate dal browser web dell’Utente.<br />
                    Vi sono vari tipi di cookie, alcuni per rendere più efficace l’uso del Sito, altri per abilitare determinate funzionalità.<br />
                    Analizzandoli in maniera particolareggiata i nostri cookie permettono di:
                </p>

                <p data-aos='fade-right' duration='1000' className="text-base font-normal text-black mb-4">
                    – permettere il normal funzionamento del sito internet.<br />
                </p>




                <div className="text-black">

                    <p data-aos='fade-right' duration='1000' className="w-full mx-auto text-left font-bold text-xl lg:mt-0 lg:mx-0">Tipologie di Cookie utilizzati da VILLA PAPA GIOVANNI XXIII S.R.L.</p>
                    <p data-aos='fade-right' duration='1000' className="text-base font-normal mb-4">
                        A seguire i vari tipi di cookie utilizzati da VILLA PAPA GIOVANNI XXIII S.R.L. in funzione delle finalità d’uso
                    </p>

                    <p data-aos='fade-right' duration='1000' className="w-full mx-auto text-left font-bold text-xl lg:mt-0 lg:mx-0">Cookie Tecnici</p>
                    <p data-aos='fade-right' duration='1000' className="text-base font-normal text-black mb-4">
                        Questa tipologia di cookie permette il corretto funzionamento di alcune sezioni del Sito. Sono di due categorie, persistenti e di sessione:<br />
                        – persistenti: una volta chiuso il browser non vengono distrutti ma rimangono fino ad una data di scadenza preimpostata;<br />
                        – di sessione: vengono distrutti ogni volta che il browser viene chiuso;<br />
                        Questi cookie, inviati sempre dal nostro dominio, sono necessari a visualizzare correttamente il sito e in relazione ai servizi tecnici offerti, verranno quindi sempre utilizzati e inviati,
                        a meno che l’utenza non modifichi le impostazioni nel proprio browser (inficiando così la visualizzazione delle pagine del sito). Essi non richiedono l’accettazione da parte dell’utente, ma solo una presa visione che sono utilizzati all’interno del sito.
                    </p>
                    <p data-aos='fade-right' duration='1000' className="text-base font-normal text-black mb-4">
                        Come disabilitare i cookie mediante configurazione del browser:<br />
                    </p>


                    <div data-aos='fade-right' duration='1000' className="flex flex-col space-y-4 mb-4">
                        <h2 className="w-full mx-auto text-left font-bold text-xl lg:mt-0 lg:mx-0">Chrome</h2>
                        <p>
                            Eseguire il Browser Chrome<br/>
                            Fare click sul menù presente nella barra degli strumenti del browser a fianco della finestra di inserimento url per la navigazione<br/>
                            Selezionare Impostazioni <br/>
                            Fare clic su Mostra Impostazioni Avanzate<br/>
                            Nella sezione “Privacy” fare clic su bottone “Impostazioni contenuti“<br/>
                            Nella sezione “Cookie” è possibile modificare le seguenti impostazioni relative ai cookie:<br/>
                            Consentire il salvataggio dei dati in locale<br/>
                            Modificare i dati locali solo fino alla chiusura del browser<br/>
                            Impedire ai siti di impostare i cookie<br/>
                            Bloccare i cookie di terze parti e i dati dei siti<br/>
                            Gestire le eccezioni per alcuni siti internet<br/>
                            Eliminazione di uno o tutti i cookie<br/>
                            Per maggiori informazioni visita la pagina dedicata.<br/>
                        </p>
                    </div>

                    <div data-aos='fade-right' duration='1000' className="flex flex-col space-y-4 mb-4">
                        <h2 className="w-full mx-auto text-left font-bold text-xl lg:mt-0 lg:mx-0">Mozilla Firefox</h2>
                        <p>
                            Eseguire il Browser Mozilla Firefox<br/>
                            Fare click sul menù presente nella barra degli strumenti del browser a fianco della finestra di inserimento url per la navigazione<br/>
                            Selezionare Opzioni<br/>
                            Seleziona il pannello Privacy<br/>
                            Fare clic su Mostra Impostazioni Avanzate<br/>
                            Nella sezione “Privacy” fare clic su bottone “Impostazioni contenuti“<br/>
                            Nella sezione “Tracciamento” è possibile modificare le seguenti impostazioni relative ai cookie:<br/>
                            Richiedi ai siti di non effettuare alcun tracciamento<br/>
                            Comunica ai siti la disponibilità ad essere tracciato<br/>
                            Non comunicare alcuna preferenza relativa al tracciamento dei dati personali<br/>
                            Dalla sezione “Cronologia” è possibile:<br/>
                            Abilitando “Utilizza impostazioni personalizzate” selezionare di accettare i cookie di terze parti (sempre, dai siti più visitato o mai) e di conservarli per un periodo determinato (fino alla loro scadenza, alla chiusura di Firefox o di chiedere ogni volta<br/>
                            Rimuovere i singoli cookie immagazzinati<br/>
                            Per maggiori informazioni visita la pagina dedicata.<br/>
                        </p>
                    </div>



                    <div data-aos='fade-right' duration='1000' className="flex flex-col space-y-4 mb-4">
                        <h2 className="w-full mx-auto text-left font-bold text-xl lg:mt-0 lg:mx-0">Internet Explorer</h2>
                        <p>
                            Eseguire il Browser Internet Explorer<br/>
                            Fare click sul pulsante Strumenti e scegliere Opzioni Internet<br/>
                            Fare click sulla scheda Privacy e nella sezione Impostazioni modificare il dispositivo di scorrimento in funzione dell’azione desiderata per i cookie:<br/>
                            Bloccare tutti i cookie<br/>
                            Consentire tutti i cookie<br/>
                            Selezione dei siti da cui ottenere cookie: spostare il cursore in una posizione intermedia in modo da non bloccare o consentire tutti i cookie, premere quindi su Siti, nella casella<br/>
                            Indirizzo Sito Web inserire un sito internet e quindi premere su Blocca o Consenti<br/>
                            Per maggiori informazioni visita la pagina dedicata.<br/>
                        </p>
                    </div>
                    <div data-aos='fade-right' duration='1000' className="flex flex-col space-y-4 mb-4">
                        <h2 className="w-full mx-auto text-left font-bold text-xl lg:mt-0 lg:mx-0">Safari 6</h2>
                        <p>
                            Eseguire il Browser Safari<br/>
                            Fare click su Safari, selezionare Preferenze e premere su Privacy<br/>
                            Nella sezione Blocca Cookie specificare come Safari deve accettare i cookie dai siti internet.<br/>
                            Per visionare quali siti hanno immagazzinato i cookie cliccare su Dettagli<br/>
                            Per maggiori informazioni visita la pagina dedicata.<br/>
                        </p>
                    </div>
                    <div data-aos='fade-right' duration='1000' className="flex flex-col space-y-4 mb-4">
                        <h2 className="w-full mx-auto text-left font-bold text-xl lg:mt-0 lg:mx-0">Safari iOS (dispositivi mobile)</h2>
                        <p>
                            Eseguire il Browser Safari iOS<br/>
                            Tocca su Impostazioni e poi Safari<br/>
                            Tocca su Blocca Cookie e scegli tra le varie opzioni: “Mai”, “Di terze parti e inserzionisti” o “Sempre”<br/>
                            Per cancellare tutti i cookie immagazzinati da Safari, tocca su Impostazioni, poi su Safari e infine su Cancella Cookie e dati<br/>
                            Per maggiori informazioni visita la pagina dedicata.<br/>
                        </p>
                    </div>

                    <div data-aos='fade-right' duration='1000' className="flex flex-col space-y-4 mb-4">
                        <h2 className="w-full mx-auto text-left font-bold text-xl lg:mt-0 lg:mx-0">Opera</h2>
                        <p>
                            Eseguire il Browser Opera<br/>
                            Fare click sul Preferenze poi su Avanzate e infine su Cookie<br/>
                            Selezionare una delle seguenti opzioni:<br/>
                            Accetta tutti i cookie<br/>
                            Accetta i cookie solo dal sito che si visita: i cookie di terze parti e che vengono inviati da un dominio diverso da quello che si sta visitando verranno rifiutati<br/>
                            Non accettare mai i cookie: tutti i cookie non verranno mai salvati<br/>
                            Per maggiori informazioni visita la pagina dedicata.<br/>
                        </p>
                    </div>


                    <div data-aos='fade-right' duration='1000' className="flex flex-col space-y-4 mb-4">
                        <h2 className="w-full mx-auto text-left font-bold text-xl lg:mt-0 lg:mx-0">Come disabilitare i cookie di servizi di terzi</h2>
                        <p>
                            Servizi di Google<br/>
                            Facebook<br/>
                            Twitter<br/>
                        </p>
                        <p>
                            Questa pagina è visibile, mediante link in calce in tutte le pagine del Sito ai sensi dell’art. 122 secondo comma del D.lgs. 196/2003 e a seguito delle modalità semplificate
                            per l’informativa e l’acquisizione del consenso per l’uso dei cookie pubblicata sulla Gazzetta Ufficiale n.126 del 3 giugno 2014 e relativo registro dei provvedimenti n.229 dell’8
                            maggio 2014.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CookiePolicy;